import { AwardCardData } from '../types';

export const AWARDS_DATA: AwardCardData[] = [
  {
    year: 2024,
    title: 'Best B2B Campaign',
    img: 'https://assets1.cleartax-cdn.com/cleartax/images/1614092745_ycomb.png',
    imgHeight: 'h-12',
    alt: 'ET Brand Disruption Awards',
    description: 'ET Brand Disruption Awards',
  },
  {
    year: 2024,
    title: 'Great Indian Employee Engagement team',
    img: '',
    imgHeight: 'h-12',
    alt: 'CHRO',
    description: 'CHRO',
  },
  {
    year: 2024,
    title: 'The Great Manager Award',
    img: '',
    imgHeight: 'h-12',
    alt: 'People Business Consulting',
    description: 'People Business Consulting',
  },
  {
    year: 2024,
    title: 'India Technology Fast 50 Award',
    img: '',
    imgHeight: 'h-12',
    alt: 'Deloitte',
    description: 'Delloite',
  },
  {
    year: 2023,
    title: 'Best B2B Campaign',
    img: 'https://assets1.cleartax-cdn.com/cleartax/images/1614092745_ycomb.png',
    imgHeight: 'h-12',
    alt: 'ET Brand Disruption Awards',
    description: 'ET Brand Disruption Awards',
  },
  {
    year: 2024,
    title: 'Excellence in Innovation 2023',
    img: '',
    imgHeight: 'h-12',
    alt: 'Economic Times',
    description: 'ET Edge',
  },
  {
    year: 2024,
    title: 'Most Innovative Fintech Data Solution Provider',
    img: '',
    imgHeight: 'h-12',
    alt: 'CMO Asia Awards',
    description: 'CMO',
  },
  {
    year: 2024,
    title: 'India Technology Fast 50 Award',
    img: '',
    imgHeight: 'h-12',
    alt: 'Deloitte',
    description: 'Delloite',
  },
  {
    year: 2023,
    title: 'Excellence in Innovation 2023',
    img: '',
    imgHeight: 'h-12',
    alt: 'Economic Times',
    description: 'ET Edge',
  },
  {
    year: 2023,
    title: 'Most Innovative Fintech Data Solution Provider',
    img: '',
    imgHeight: 'h-12',
    alt: 'CMO Asia Awards',
    description: 'CMO',
  },
  {
    year: 2023,
    title: 'India Technology Fast 50 Award',
    img: '',
    imgHeight: 'h-12',
    alt: 'Deloitte',
    description: 'Delloite',
  },
  {
    year: 2023,
    title: 'Great Indian Employee Engagement team',
    img: '',
    imgHeight: 'h-12',
    alt: 'CHRO',
    description: 'CHRO',
  },
  {
    year: 2023,
    title: 'Most Trusted Brand award',
    img: '',
    imgHeight: 'h-12',
    alt: 'Marksmen Daily',
    description: 'Marksmen Daily',
  },
];
